<template>
  <el-button size="mini" type="text" @click="onSubmit" title="Delete">
    Delete
  </el-button>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  props: {
    snapId: String,
  },
  methods: {
    async onSubmit() {
      this.loading = true
      try {
        await this.$confirm('The food snap will be permanently deleted.', 'Confirm Delete', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }
      try {
        var { data } = await this.$http.delete(`/snaps/${ this.snapId }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.$emit('delete')
      this.$message.success(data.message)
    },
  },
}
</script>
